<template>
  <div style="margin-top: 10px">
    <div class="pd10">
      <el-tree ref="tree" :data="permList" show-checkbox node-key="id" :default-expanded-keys="expandedkeys" :default-checked-keys="checkedkeys" :props="defaultProps"> </el-tree>
    </div>
    <div class="form-but mt10">
      <el-button type="success" :loading="loading" @click="permsUpdate">保存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'permSave',
  created() {},
  data() {
    return {
      loading: false,
      permList: [],
      expandedkeys: [],
      checkedkeys: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      id: 0,
      perms: ''
    }
  },
  methods: {
    //获取选中树型
    handleSubmit() {
      // getCheckedKeys 若节点可被选择（即 show-checkbox 为 true），则返回目前被选中的节点的 key 所组成的数组。
      // (leafOnly) 接收一个 boolean 类型的参数，若为 true 则仅返回被选中的叶子节点的 keys，默认值为 false
      // var parentIds = this.$refs.tree.getHalfCheckedKeys()
      var childsIds = this.$refs.tree.getCheckedKeys(true)
      // 利用set没有重复的值这一特性, 实现数组去重。Array.from方法可以将 Set 结构转为数组。
      // const perms = JSON.stringify(Array.from(new Set(childsIds)))
      this.perms = childsIds.join(',')
      console.log(123, this.perms)
    },
    //保存
    async permsUpdate() {
      this.handleSubmit()
      const params = {
        id: this.id,
        perms: this.perms
      }
      await this.$api.position.permsUpdate(params).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.$emit('callMethod')
        }
      })
    },
    //父页面传数据
    setData(id) {
      this.id = id
      this.$refs.tree.setCheckedKeys([]) //清空勾选
      this.getPositionPermID()
    },
    //获取职位权限
    async getPositionPermID() {
      await this.$api.position.perms({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.checkedkeys = res.data
          this.getAuthPerms()
        }
      })
    },
    //获取权限列表
    async getAuthPerms() {
      await this.$api.auth.permList().then(res => {
        if (res.code != 200) return
        this.permList = res.data ?? []
      })
    }
  }
}
</script>
